/**
 * @file
 * Make sure content will be visible after Cookiehub has initialized.
 */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.fulbrightCookiehub = {
    attach: function (context, settings) {
      if (window.cookiehub && window.cookiehub.hasConsented('marketing')) {
        $('[data-consent="marketing"]').each(function (index, el) {
          if (!el.src && $(el).data('src')) {
            el.src = $(el).data('src');
          }
        });

        // Hide all marketing cookie notices. This will make sure "responsive"
        // Issuu embeds will work fine. First approach (hide sibling notices
        // based on iframe attributes) did not work because of Issuee embed
        // wrapping div.
        $('.marketing-cookies-notice').hide();
      }
    }
  };

})(jQuery, Drupal);
